import styled from "styled-components";
import { rem } from "convert-to-ems";

export const ListElement = styled.div`
  width: ${props => rem(props.width)};
  margin: 0 auto;
  padding-top: ${props => rem(props.paddingTop)};
  padding-left: ${props => rem(props.paddingLeft)};
  padding-bottom: ${props => rem(props.paddingBottom)};
  padding-right: ${props => rem(props.paddingRight)};

  @media (${props => props.theme.breakpoints.mobile}) {
    width: 100%;
    padding-left: ${rem(0)};
  }
  @media (${props => props.theme.breakpoints.tablet}) {
    width: 100%;
    padding-left: ${rem(0)};
  }
`;
